@if (initialized) {
    <router-outlet></router-outlet>
}
